module.exports = __webpack_public_path__ + "static/media/ft.4c6125e0.jpg";